export default function CartDrawer() {
    // cart drawer trigger
    if ($('#CartDrawer').length) {
        $('.main-header .cart-link').click(function(e) {
            e.preventDefault();
            $('cart-drawer.drawer').toggleClass('active');
        });
    }

    // shipping bar
      const ipinfoUrl = "https://ipinfo.io/json";

      fetch(ipinfoUrl)
        .then(response => response.json())
        .then(data => {
          if (data.country == "US") {
            $('body').addClass('show-shipping-bar');
          }
         
        })
        .catch(error => console.error("Error fetching IP info:", error));
}